module.exports = __webpack_public_path__ + "img/ddakji.6b26c833.png";